import React from 'react'
import { useHistory } from 'react-router-dom'
import helpers from '~/Classes/helpers'
import axios from '~/data/http/axios'
import queryString from 'query-string'
import CapsuleConfig from '../cp/company/integrations/apps/capsule/setup'

export default function CapsuleLandingPage() {
    const history = useHistory()

    const postLoginChecks = () => {
        // if they have a redirect check their capsule integration first as it might need to be finished beforehand
        var query = queryString.parse(location.search)
        if (query.redirect) {
            if (query.redirect !== '/cp/capsule') {
                axios.get('/accountMaster/application').then((res) => {
                    if (
                        res.data.Applications &&
                        res.data.Applications.some((a) => a.ApplicationId === 8 && !a.appSettings.groupId)
                    ) {
                        // change the redirect to go to capsule setup instead
                        helpers.safeRedirect('/cp/capsule?redirect=' + query.redirect, 'self', history)
                    } else {
                        helpers.safeRedirect(query.redirect, 'self', history)
                    }
                })
            } else {
                helpers.safeRedirect(query.redirect, 'self', history)
            }
        } else {
            // all good go home
            window.open('/cp', '_self')
        }
    }

    return <CapsuleConfig onFinish={postLoginChecks} />
}
